// src/modules/leads/api.js
import API from '../../services/api';

const base = '/leads';

// Lead types
export const fetchLeadTypes = () => API.get(`${base}/types`);
export const createLeadType = (data) => API.post(`${base}/types`, data);
export const updateLeadType = (id, data) => API.patch(`${base}/types/${id}`, data);
export const deleteLeadType = (id) => API.delete(`${base}/types/${id}`);

// Lead sources (admin-configurable)
export const fetchLeadSources = () => API.get(`${base}/sources`);
export const createLeadSource = (data) => API.post(`${base}/sources`, data);
export const updateLeadSource = (id, data) => API.patch(`${base}/sources/${id}`, data);
export const deleteLeadSource = (id) => API.delete(`${base}/sources/${id}`);

// Lead statuses / interest levels (admin-configurable: Hot, Cold, …)
export const fetchLeadStatuses = () => API.get(`${base}/statuses`);
export const createLeadStatus = (data) => API.post(`${base}/statuses`, data);
export const updateLeadStatus = (id, data) => API.patch(`${base}/statuses/${id}`, data);
export const deleteLeadStatus = (id) => API.delete(`${base}/statuses/${id}`);

// Leads
export const fetchLeads = (params) => API.get(base, { params });
export const fetchMyQueue = () => API.get(`${base}/my-queue`);
export const fetchLead = (id) => API.get(`${base}/${id}`);
export const createLead = (data) => API.post(base, data);
export const updateLead = (id, data) => API.patch(`${base}/${id}`, data);
export const deleteLead = (id) => API.delete(`${base}/${id}`);
export const importLeads = (data) => API.post(`${base}/import`, data);
export const assignLeads = (data) => API.post(`${base}/assign`, data);
export const logLeadActivity = (id, data) => API.post(`${base}/${id}/activity`, data);
export const fetchAssignableCsrs = (params) => API.get(`${base}/assignable-csrs`, { params });

// Analytics
export const fetchLeadOverview = (params) => API.get(`${base}/analytics/overview`, { params });
export const fetchLeadByGroup = (params) => API.get(`${base}/analytics/by-group`, { params });
export const fetchLeadTimeSeries = (params) => API.get(`${base}/analytics/time-series`, { params });
export const rebuildLeadSnapshots = (data) => API.post(`${base}/analytics/snapshot`, data);
